// open leads (v2)
export const GET_OPEN_LEADS_REQUEST = 'GET_OPEN_LEADS_REQUEST';
export const GET_OPEN_LEADS_SUCCESS = 'GET_OPEN_LEADS_SUCCESS';
export const GET_OPEN_LEADS_ERROR = 'GET_OPEN_LEADS_ERROR';

export const UPDATE_OPEN_LEAD_REQUEST = 'UPDATE_OPEN_LEAD_REQUEST';
export const UPDATE_OPEN_LEAD_SUCCESS = 'UPDATE_OPEN_LEAD_SUCCESS';
export const UPDATE_OPEN_LEAD_ERROR = 'UPDATE_OPEN_LEAD_ERROR';

export const UPDATE_LEAD_FINANCING_REQUEST = 'UPDATE_LEAD_FINANCING_REQUEST';
export const UPDATE_LEAD_FINANCING_SUCCESS = 'UPDATE_LEAD_FINANCING_SUCCESS';
export const UPDATE_LEAD_FINANCING_ERROR = 'UPDATE_LEAD_FINANCING_ERROR';

// general
export const SUBMIT_LEAD_SALE_STATES_REQUEST =
  'SUBMIT_LEAD_SALE_STATES_REQUEST';
export const SUBMIT_LEAD_SALE_STATES_SUCCESS =
  'SUBMIT_LEAD_SALE_STATES_SUCCESS';
export const SUBMIT_LEAD_SALE_STATES_ERROR = 'SUBMIT_LEAD_SALE_STATES_ERROR';
